<template>
    <svg height="15" viewBox="0 0 18 15" width="18" xmlns="http://www.w3.org/2000/svg">
        <g fill="rgb(78, 140, 255)" fill-rule="nonzero">
            <path
                d="M16.144 14.62c.412 0 .77-.133 1.073-.399L12.02 9.096l-.36.255c-.39.283-.705.503-.947.661-.243.159-.565.32-.968.485-.403.165-.778.247-1.126.247h-.02c-.349 0-.724-.082-1.127-.247a5.848 5.848 0 0 1-.967-.485 24.116 24.116 0 0 1-.947-.661 45.017 45.017 0 0 0-.36-.256L0 14.22c.304.266.661.4 1.074.4h15.07zM1.06 5.247A5.525 5.525 0 0 1 0 4.357v7.895L4.696 7.68A363.54 363.54 0 0 0 1.06 5.247zM16.95 5.247a309.7 309.7 0 0 0-3.646 2.434L18 12.252V4.358a5.75 5.75 0 0 1-1.05.889zM16.393.41H1.607C1.091.41.695.578.417.914.139 1.25 0 1.67 0 2.174c0 .407.184.848.552 1.323.369.475.76.848 1.176 1.12.227.155.914.615 2.059 1.38a666.726 666.726 0 0 1 2.632 1.77l.15.103.277.192c.217.152.398.275.542.369.144.093.318.198.522.315a3.1 3.1 0 0 0 .578.261c.18.058.348.088.502.088h.02c.154 0 .322-.03.502-.088.181-.058.374-.145.578-.261.204-.117.378-.222.522-.315.144-.094.325-.217.543-.369a67.374 67.374 0 0 1 .427-.295l1.016-.682 3.685-2.468c.489-.33.897-.727 1.225-1.192.328-.466.492-.953.492-1.464 0-.426-.16-.791-.477-1.095a1.582 1.582 0 0 0-1.13-.456z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "MailForm",
};
</script>



// WEBPACK FOOTER //
// src/components/svg/MailForm.vue